module.exports = __webpack_public_path__ + "static/media/win.bdb9cde7.wav";